import trackerMatches from './trackerMatches.js';
const getTrackerCategory = (trackerId, config) => {
  const category = config.categories.find(category => category.trackers.find(tracker => trackerMatches(tracker, trackerId)));
  return category;
};
export { getTrackerCategory as default };
//# sourceMappingURL=getTrackerCategory.js.map
